exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links[data-v-5d59029c]{display:flex;flex-wrap:wrap}.action-card[data-v-5d59029c]{margin:20px 0;align-self:flex-start;box-shadow:0 0 10px rgba(0,0,0,.3)}.file-limit-reached[data-v-5d59029c]{padding:0 5px;color:#ccc}", ""]);

// exports
